/////////////////////////////////////////
import type { RootStore } from 'store';

let devSsoState: DevSsoState | undefined;

// Imported before the application's setup, auth restoration, and tab synchronization.
(function captureDevSso() {
  if (typeof location === 'undefined' || typeof history === 'undefined') return;
  const url = new URL(location.href);
  const hadToken = url.searchParams.has('loginToken');
  if (!hadToken) return;
  const tokens = url.searchParams.getAll('loginToken');
  url.searchParams.delete('loginToken');
  let token: string | undefined;
  const state: DevSsoState = {
    status: 'failed',
    takeToken() {
      const value = token;
      token = undefined;
      return value;
    },
  };
  devSsoState = state;
  try {
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  } catch (_) {
    // The gate renders this initial failed state without retrying or navigating.
    return;
  }
  if (tokens.length === 1 && tokens[0].trim()) {
    token = tokens[0];
    state.status = 'captured';
  }
})();

export type DevSsoStatus = 'captured' | 'pending' | 'succeeded' | 'failed';
export interface DevSsoState {
  status: DevSsoStatus;
  takeToken?: () => string | undefined;
  listeners?: Set<() => void>;
  store?: RootStore;
  promise?: Promise<void>;
}

export function getDevSsoState(): DevSsoState | undefined {
  return devSsoState;
}

//////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
//////////////////////
 
/////////

// Keep this tab isolated from old sessions for the whole token-login document.
export function isDevSsoAttempt(): boolean {
  return Boolean(getDevSsoState());
}

export function reuseDevSsoStore(create: () => RootStore): RootStore {
  const state = getDevSsoState();
  if (!state) return create();
  state.store ??= create();
  return state.store;
}
/////////
